import * as React from "react";
import {
    Box,
    Grid,
    Typography,
    Card
} from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import PrintIcon from '@mui/icons-material/Print';
import { FabricDetailSheet, ArticleTicket, PackingSlip } from 'src/resources/sales';
import ReactToPrint from 'react-to-print';
import Html2Pdf from 'html2pdf.js';
import { useRef } from "react";

export const PackingList = (props) => {
  const { record } = props
  const printDetailSheetRef = useRef<HTMLDivElement>(null);
  const printArticleTicketRef = useRef<HTMLDivElement>(null);
  const printPackingSlipRef = useRef<HTMLDivElement>(null);

  const cardStyle = {
    padding: "10px",
    border: "1px solid #ebebeb",
    borderRadius: "8px"
  };

  return (
    <>
    <Card sx={cardStyle}>
        <Grid item sm={12} md={12} sx={{display: "flex", marginBottom: "3px", marginTop: "3px", justifyContent: "space-between", alignItems: "center"}}>                         
            <Typography variant="subtitle2">Packing Slip</Typography>
            <Box sx={{alignItems: "center", display: "flex"}}>
                <DownloadIcon 
                    sx={{cursor: "pointer", marginRight: "8px"}}
                    color="primary"
                    onClick={() => {
                        new Html2Pdf(printPackingSlipRef.current,{margin: [10, 10, 10, 10], filename:`Packing Slip #${record.increment_id}.pdf`});
                    }}
                />
                <ReactToPrint
                    pageStyle="@page { size: auto;  margin:  0 20px; }"
                    copyStyles={true}
                    documentTitle={`Packing Slip #${record.increment_id}`}
                    content={() => printPackingSlipRef.current}
                    trigger={() => {
                    return (
                        <PrintIcon sx={{cursor: "pointer"}} color="primary"/>
                    );
                    }}
                />
            </Box>
        </Grid>

        {record.type === 'fabric' &&
        <>
        <Grid item sm={12} md={12} sx={{display: "flex", marginBottom: "3px", marginTop: "3px", justifyContent: "space-between", alignItems: "center"}}>                         
            <Typography variant="subtitle2">Fabric Detail Sheets</Typography>
            <Box sx={{alignItems: "center", display: "flex"}}>
                <DownloadIcon 
                    sx={{cursor: "pointer", marginRight: "8px"}}
                    color="primary"
                    onClick={() => {
                        new Html2Pdf(printDetailSheetRef.current,{margin: [10, 10, 10, 10], filename:`Fabric Detail Sheet #${record.increment_id}.pdf`});
                    }}
                />
                <ReactToPrint
                    pageStyle="@page { size: auto;  margin:  0 20px  }"
                    documentTitle={`Fabric Detail Sheet #${record.increment_id}`}
                    content={() => printDetailSheetRef.current}
                    trigger={() => {
                    return (
                        <PrintIcon sx={{cursor: "pointer"}} color="primary"/>
                    );
                    }}
                />
            </Box>
        </Grid>

        <Grid item sm={12} md={12} sx={{display: "flex", marginBottom: "3px", marginTop: "3px", justifyContent: "space-between", alignItems: "center"}}>                         
            <Typography variant="subtitle2">Article Tickets</Typography>
            <Box sx={{alignItems: "center", display: "flex"}}>
                <DownloadIcon 
                    sx={{cursor: "pointer", marginRight: "8px"}}
                    color="primary"
                    onClick={() => {
                        new Html2Pdf(printArticleTicketRef.current,{margin: [10, 10, 10, 10], filename:`Article Ticket #${record.increment_id}.pdf`});
                    }}
                />
                <ReactToPrint
                    pageStyle="@page { size: auto;  margin:  0 20px  }"
                    documentTitle={`Article Ticket #${record.increment_id}`}
                    content={() => printArticleTicketRef.current}
                    trigger={() => {
                    return (
                        <PrintIcon sx={{cursor: "pointer"}} color="primary"/>
                    );
                    }}
                />
            </Box>
        </Grid>
        </>
        }
    </Card>
    <Box sx={{display: "none"}}>
        <Box ref={printDetailSheetRef} >
        { record.items.map((orderItem, orderItemIndex) => {
            return (
                <FabricDetailSheet key={orderItemIndex} record={orderItem}/>
            )
        })}
        </Box>

        <Box ref={printArticleTicketRef} >
        { record.items.map((orderItem, orderItemIndex) => {
            return (
                <ArticleTicket key={orderItemIndex} record={orderItem}/>
            )
        })}
        </Box>
        <Box ref={printPackingSlipRef} >
            <PackingSlip record={record}/>
        </Box>
    </Box>
    </>
  );
};
